import { Banner } from '../types';
import {
  getAllBanners as apiGetAllBanners,
  addBanner as apiAddBanner,
  updateBanner as apiUpdateBanner,
  deleteBanner as apiDeleteBanner,
  uploadBannerImage as apiUploadBannerImage
} from '../../../api/bannerManagement';

interface GetAllBannersParams {
  bannerLocation: string;
  page: number;
  pageSize: number;
  search?: string;
  platform?: string;
}

interface GetAllBannersResponse {
  page: number;
  paginatedResults: Banner[];
  totalCount: number;
  totalPages: number;
}

class BannerService {
  async getAllBanners(params: GetAllBannersParams): Promise<GetAllBannersResponse> {
    return apiGetAllBanners(params);
  }

  async createBanner(banner: any): Promise<any> {
    return apiAddBanner(banner);
  }

  async updateBanner(id: string, banner: Partial<Banner>): Promise<Banner> {
    return apiUpdateBanner({ id, payload: banner });
  }

  async deleteBanner(id: string): Promise<void> {
    return apiDeleteBanner(id);
  }

  async uploadBannerImage(file: File): Promise<string> {
    return apiUploadBannerImage(file);
  }
}

export const bannerService = new BannerService(); 